//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "div-notice",
  data() {
    return {

    }
  },
  props:['list','text','noFlag'],

  methods: {

  },



}



// WEBPACK FOOTER //
// ./src/components/div-notice.vue